import React, { useMemo } from "react";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnQualification, ColumnRank, ColumnExpander } from "components/common/TableColumns"
import NotAvailable from "components/common/NotAvailable";
import { filterArray, findArray } from 'helpers/utils'
import Label from "components/general/Label";


function KteKata({ data }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  let shortDescription = data?.results?.eventUnit?.shortDescription;
  let _caption = shortDescription

  const tableColumns = useMemo(() =>
    [
      ColumnRank({ disableSort: true }),
      ColumnBib({ accessor: 'startSortOrder', disableSort: true }),
      ColumnNoc({ disableSort: true }),
      ColumnName({ disableSort: true, headerClassName: "w-40" }),
      {
        id: 'Kata',
        Header: <Label data={'HeaderKata'} />,
        accessor: 'code',
        className: 'text-start',
        Cell: (props) => {
          let row = props.cell.row.original
          let kata = row?.extendedResults?.find(filter => filter.er_code === 'KATA')?.extensions?.find(filter => (filter.ere_code === 'NAME'))?.ere_value
          return (
            kata && kata
          )
        }
      },
      ColumnResult({ label: 'HeaderScore' })
    ], []
  )
  const renderRowSubComponent = React.useCallback(({ row }) => {
    const katas = filterArray(row?.original?.extendedResults, { er_code: ['KATA'] })
    let kata = [];
    katas.forEach(item => {
      kata.push(
        <>
          <tr>
            <td rowspan="2" className="w-40">{item?.extensions?.find(filter => (filter.ere_code === 'NAME'))?.ere_value}</td>
            <td><Label data="LabelTechPerf" /></td>
            <td className="text-center">{item?.extensions?.find(filter => (filter.ere_code === 'SCORE' && filter.ere_pos === 'T'))?.ere_value}</td>
            {item?.er_pos === "1" && <td rowspan={2 * katas.length} className="text-center">{item?.er_value}</td>}
            {item?.er_pos === "1" && <td rowspan={2 * katas.length} className="text-center">{row?.original?.resultRank}</td>}
          </tr>
          <tr>
            <td><Label data="LableAthPerf" /></td>
            <td className="text-center">{item?.extensions?.find(filter => (filter.ere_code === 'SCORE' && filter.ere_pos === 'A'))?.ere_value}</td>
          </tr>
        </>
      )
    });
    let Expanded = (
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th colspan="3"><Label data="HeaderKata" /></th>
            <th className="w-10 text-center"><Label data="HeaderScore" /></th>
            <th className="w-10 text-center"><Label data="HeaderRank" /></th>
          </tr>
        </thead>
        <tbody>
          {kata}
        </tbody>
      </table >
    )
    return (
      <LoaderSubComponent component={Expanded} />
    )
  }, []);

  return (
    <>

      {data?.results ? (
        <>
          {data?.results?.items ? (
            <MirsTable
              id={`mirs-table-katas-${mirs_rsc}`}
              caption={_caption}
              data={data?.results?.items}
              columns={tableColumns}
              keyRow={"athlete-code"}
              hiddenColumns={['Bib']}
              initialSortBy={[{ id: 'Rank', desc: false }, { id: 'Bib', desc: false }]}
              colIndex={1}
              renderRowSubComponent={renderRowSubComponent}
            />
          ) : ('')
          }
        </>
      ) : (
        <NotAvailable />
      )
      }
    </>
  )

}



export default KteKata;